import { React, useState, useEffect, useContext } from 'react'; 
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/authContext';

import { useDisclosure } from '@mantine/hooks';
import { TextInput, FileInput, Modal, Button, Group, Autocomplete } from '@mantine/core';
import { useForm } from '@mantine/form';

import SyndicRectangleButton from '../../composents/Buttons/Syndic/RectangleButton/RectangleButtonMain'
import AppHdWithReturnLeft from '../../composents/Headers/AppHeaders/AppHdWithReturnLeft/AppHdWithReturnLeft';

const AddCustomer = () => {
    const { getToken } = useContext(AuthContext);
    const [ isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const [ openedSyndicModal, { open: openSyndicModal, close: closeSyndicModal} ] = useDisclosure(false)
    const [ openedConfirmationModal, { open: openConfirmationModal, close: closeConfirmationModal}] = useDisclosure(false)

    const [ queryStreet, setQueryStreet ] = useState('');
    const [ optionsStreet, setOptionsStreet ] = useState([]);
    const [ streetSubmit, setStreetSubmit ] = useState('');

    const [ queryCityCie, setQueryCityCie ] = useState('');
    const [ optionsCityCie, setOptionsCityCie ] = useState([]);
    const [ cityCieSubmit, setCityCieSubmit ] = useState('');

    const [ logo, setLogo ] = useState();
    const [ error, setError ] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/adm/login");
            return;
        };

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
      
        window.addEventListener('resize', handleResize);
        return () => {
        window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      },[]);
  

    const formSyndic = useForm({
        initialValues: {
            lastname: '',
            firstname: '',
            email: '',
            phone: '',
            occupation: '',
            namecie: '',
            siretnb : '',
            logo: '',
            no: '',
            street: '',
            postalcode: '',
            city: '',
            country: '',
            phonecie: '',
            emailcie: ''
        },

        validate: {
            lastname : (value) => (
                value.length < 1
                ? 'Renseignez le nom de l\'utilisateur syndic'
                : value.length > 30 
                ? '30 caractères max.' 
                : null
            ),
            firstname : (value) => (
                value.length < 1 
                ? 'Renseignez le prénom de l\'utilisateur syndic'
                : value.length > 30 
                ? '30 caractères max.'
                : null
            ),
            email : (value) => (
                value.length < 1
                ? 'Renseignez l\'E-mail de l\'utilisateur syndic'
                : /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value) 
                ? null 
                : 'E-mail non valide'
            ),
            phone: (value) => (
                value && !/^[0-9]{10}$/.test(value) 
                ? 'Numéro de téléphone invalide' 
                : null),
            occupation : (value) => (
                value.length > 50
                ? '50 caractères maximum'
                : null
            ),
            namecie : (value) => (
                value.length < 1 
                ? 'Renseignez la désignation de la société'
                : value.length > 30
                ? '30" caractères maximum'
                : null
            ),
            siretnb : (value) => (
                value && !/^[0-9]{14}$/.test(value) 
                ? 'Numéro de siret invalide' 
                : null),
            no : (value) => (value.length < 1 ? 'Saisir le n° de la voirie' : null),
            postalcode : (value) => (
                value && !/^[0-9]{5}$/.test(value) 
                ? 'Code postal invalide' 
                : null),
            country : (value) => (
                value.length < 1 
                ? 'Renseignez la commune de la société'
                : value.length > 35 
                ? '35 caractères max.'
                : null
            ),
            phonecie: (value) => (
                value && !/^[0-9]{10}$/.test(value) 
                ? 'Numéro de téléphone invalide' 
                : null),
            emailcie : (value) => (
                value.length < 1
                ? 'Renseignez l\'E-mail de contact de la société'
                : /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value) 
                ? null 
                : 'E-mail non valide'
            )   
        }
    });

    const handleStreetQueryChange = async (value) => {
        setQueryStreet(value);
    
        if (value) {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/adm/bu/search-address', {
                    method: 'POST',
                    body: JSON.stringify({ query: value }),
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }          
                })

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                  }
                const data = await response.json();
                const suggestions = data.features
                    .map((feature) => ({
                        value: feature.properties.street || '',
                        label: feature.properties.street || '',
                    }))
                    .filter((item, index, self) =>
                        index === self.findIndex((t) => t.value === item.value)
                    );
                    

                setOptionsStreet(suggestions);
            } catch (error) {
            }
        }
    }

    const handleStreetQuerySubmit = (streetSelected) => {
        setStreetSubmit(streetSelected)
    };

    const handleCityCieQueryChange = async (value) => {
        setQueryCityCie(value);
    
        if (value) {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/adm/bu/search-address', {
                    method: 'POST',
                    body: JSON.stringify({ query: value }),
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }          
                })

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                  }
                const data = await response.json();
                const suggestions = data.features
                    .map((feature) => ({
                        value: feature.properties.city || '',
                        label: feature.properties.city || '',
                    }))
                    .filter((item, index, self) =>
                        index === self.findIndex((t) => t.value === item.value)
                    );
                    
                setOptionsCityCie(suggestions);
            } catch (error) {
            }
        }
    }

    const handleCityCieQuerySubmit = (citySelected) => {
        setCityCieSubmit(citySelected)
    };


    const HandleOpenSyndicModal = () => {
        openSyndicModal();
    }

    const handleSyndicFormSubmit = async (values, _event) => {
        if(logo === undefined) {
            setLogo('')
        }
        _event.preventDefault();

        try {
            const token = localStorage.getItem('token');
            const response = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/adm/bu/addScust", {
                method: "POST",
                body: JSON.stringify({
                    lastname: values.lastname,
                    firstname: values.firstname,
                    email: values.email,
                    phone: values.phone,
                    occupation: values.occupation,
                    name: values.namecie,
                    siret_nb: values.siretnb,
                    logo: logo,
                    no: values.no,
                    street: streetSubmit.target.value,
                    postalcode: values.postalcode,
                    city: cityCieSubmit.target.value,
                    country: values.country,
                    phonecie: values.phonecie,
                    emailcie: values.emailcie
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            if(response.ok) {
                setTimeout(() => {
                    closeSyndicModal()
                    openConfirmationModal()
                    window.location.reload();
                }, 1000)
            } else {
                const errorResponse = await response.json();
                if (errorResponse.error === 'Cet email est déjà utilisé par un autre prestataire.') {
                    setError('Email déjà utilisé utilisé par un autre prestataire.');
                }  
            } 
        } catch (error) {
        }
    }

    const fileBrowseHandler = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event)
        reader.onload = () => {
          setLogo(reader.result)
        };
        reader.onerror = function (error) {
        }
    }

    const handlecloseSyndicModal = () => {
        setError('');
        closeSyndicModal();
    }


    return(
        <>{isMobile ? (
            <>
                <AppHdWithReturnLeft>Créer un compte Donneur d'ordres de type entreprise</AppHdWithReturnLeft>
                
                <div className='width90pCenter'>
                    <form>
                            <>
                            <h3 className="noMrgB terracotaT">Donneur d'ordres de type entreprise</h3>
                            <hr></hr>
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Nom"
                                placeholder="Dupont"
                                withAsterisk
                                {...formSyndic.getInputProps('lastname')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Prénom"
                                placeholder="Henry"
                                withAsterisk
                                {...formSyndic.getInputProps('firstname')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Email"
                                placeholder="Email"
                                withAsterisk
                                {...formSyndic.getInputProps('email')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="N° de téléphone direct"
                                placeholder="XXXXXXXXXX"
                                withAsterisk
                                {...formSyndic.getInputProps('phone')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Titre du poste"
                                placeholder="Maître d'ouvrages"                                
                                {...formSyndic.getInputProps('occupation')}
                            />
                            <div className="mrgB30"></div>

                            <h3 className="noMrgB terracotaT">Société</h3>
                            <hr></hr>

                            <TextInput
                                label="Désignation sociale de la société"
                                placeholder="Nom de l'entreprise"
                                withAsterisk
                                {...formSyndic.getInputProps('namecie')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                placeholder="N° Siret"
                                label="N° Siret"
                                withAsterisk
                                {...formSyndic.getInputProps('siretnb')}
                            />
                            <div className="mrgB10"></div>

                            <FileInput
                                placeholder="Télécharger"
                                label="Logo"
                                onChange={fileBrowseHandler}
                                clearable
                                accept="image/png,image/jpeg,image/jpg"
                            />

                            <p className="thin txt15 mrgT20 mrgB5 terracotaT">Adresse postale</p>
                            <TextInput
                                placeholder="N°"
                                label="Numéro de rue"
                                withAsterisk
                                {...formSyndic.getInputProps('no')}
                            />
                            <div className="mrgB10"></div>

                            <Autocomplete
                                label="Nom de rue"
                                placeholder="Nom de rue"
                                withAsterisk
                                value={queryStreet}
                                onChange={handleStreetQueryChange}
                                onSelect={handleStreetQuerySubmit}
                                data={optionsStreet}
                                textFieldProps={{ required: true }}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                placeholder="Code postal"
                                label="Code postal"
                                withAsterisk
                                {...formSyndic.getInputProps('postalcode')}
                            />
                            <div className="mrgB10"></div>

                            <Autocomplete
                                placeholder="Commune"
                                label="Commune"
                                withAsterisk
                                value={queryCityCie}
                                onChange={handleCityCieQueryChange}
                                onSelect={handleCityCieQuerySubmit}
                                data={optionsCityCie}
                                textFieldProps={{ required: true }}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                placeholder="Pays"
                                label="Pays"
                                withAsterisk
                                {...formSyndic.getInputProps('country')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="N° de téléphone siège / agence"
                                placeholder="XXXXXXXXXX"
                                withAsterisk
                                {...formSyndic.getInputProps('phonecie')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Email général siège / agence"
                                placeholder="Email"
                                withAsterisk
                                {...formSyndic.getInputProps('emailcie')}
                            />

                            <div className="mrgB30"></div>
    
                            <SyndicRectangleButton onClick={HandleOpenSyndicModal}>
                                Enregistrer
                            </SyndicRectangleButton>
                            </>
                            {openSyndicModal  
                                ?   <Modal 
                                        centered
                                        withCloseButton={false}    
                                        opened={openedSyndicModal} 
                                        onClose={closeSyndicModal}
                                        size="auto">
                                            <Group noWrap mt="md" className=" txtCenter mrgT5 txt15">
                                                Valider la création du nouveau compte Syndic
                                            </Group>
                                            {error && <p className='txt13 rT'>Erreur : {error}</p>}
                                            <Group mt="xl" className="txtCenter horizontal spaceArd mrgT20 w80">
                                                <Button variant="outline" color="dark" onClick={handlecloseSyndicModal}>
                                                    Annuler
                                                </Button>
                                                <Button variant="filled" color="dark" onClick={formSyndic.onSubmit(handleSyndicFormSubmit)}  className=' medium'>
                                                    Valider
                                                </Button>
                                        </Group>       
                                    </Modal> 
                                :   ""
                            }  
                    </form>
                                        
                    <div className="mrgB30"></div>
                    {openConfirmationModal  
                            ?   <Modal 
                                    centered
                                    size="auto"
                                    
                                    opened={openedConfirmationModal}
                                    onClose={closeConfirmationModal}
                                    withCloseButton={false}>
                                    <p className=" txt15 txtCenter noMrgTB">
                                        Utilisateur enregistré avec succès
                                    </p>
                                </Modal> 
                            :   ""
                    }
                </div>
            </>
        ) : (
            <>
                <AppHdWithReturnLeft>Créer un compte Donneur d'ordres de type entreprise</AppHdWithReturnLeft>
                
                <div className='width90pCenter'>
                    <form>
                            <>
                            <h3 className="noMrgB terracotaT">Donneur d'ordres de type entreprise</h3>
                            <hr></hr>
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Nom"
                                placeholder="Dupont"
                                withAsterisk
                                {...formSyndic.getInputProps('lastname')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Prénom"
                                placeholder="Henry"
                                withAsterisk
                                {...formSyndic.getInputProps('firstname')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Email"
                                placeholder="Email"
                                withAsterisk
                                {...formSyndic.getInputProps('email')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="N° de téléphone direct"
                                placeholder="XXXXXXXXXX"
                                withAsterisk
                                {...formSyndic.getInputProps('phone')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Titre du poste"
                                placeholder="Maître d'ouvrages"                                
                                {...formSyndic.getInputProps('occupation')}
                            />
                            <div className="mrgB30"></div>

                            <h3 className="noMrgB terracotaT">Société</h3>
                            <hr></hr>

                            <TextInput
                                label="Désignation sociale de la société"
                                placeholder="Nom de l'entreprise"
                                withAsterisk
                                {...formSyndic.getInputProps('namecie')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                placeholder="N° Siret"
                                label="N° Siret"
                                withAsterisk
                                {...formSyndic.getInputProps('siretnb')}
                            />
                            <div className="mrgB10"></div>

                            <FileInput
                                placeholder="Télécharger"
                                label="Logo"
                                onChange={fileBrowseHandler}
                                clearable
                                accept="image/png,image/jpeg,image/jpg"
                            />

                            <p className="thin txt15 mrgT20 mrgB5 terracotaT">Adresse postale</p>
                            <TextInput
                                placeholder="N°"
                                label="Numéro de rue"
                                withAsterisk
                                {...formSyndic.getInputProps('no')}
                            />
                            <div className="mrgB10"></div>

                            <Autocomplete
                                label="Nom de rue"
                                placeholder="Nom de rue"
                                withAsterisk
                                value={queryStreet}
                                onChange={handleStreetQueryChange}
                                onSelect={handleStreetQuerySubmit}
                                data={optionsStreet}
                                textFieldProps={{ required: true }}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                placeholder="Code postal"
                                label="Code postal"
                                withAsterisk
                                {...formSyndic.getInputProps('postalcode')}
                            />
                            <div className="mrgB10"></div>

                            <Autocomplete
                                placeholder="Commune"
                                label="Commune"
                                withAsterisk
                                value={queryCityCie}
                                onChange={handleCityCieQueryChange}
                                onSelect={handleCityCieQuerySubmit}
                                data={optionsCityCie}
                                textFieldProps={{ required: true }}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                placeholder="Pays"
                                label="Pays"
                                withAsterisk
                                {...formSyndic.getInputProps('country')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="N° de téléphone siège / agence"
                                placeholder="XXXXXXXXXX"
                                withAsterisk
                                {...formSyndic.getInputProps('phonecie')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Email général siège / agence"
                                placeholder="Email"
                                withAsterisk
                                {...formSyndic.getInputProps('emailcie')}
                            />

                            <div className="mrgB30"></div>
    
                            <SyndicRectangleButton onClick={HandleOpenSyndicModal}>
                                Enregistrer
                            </SyndicRectangleButton>
                            </>
                            {openSyndicModal  
                                ?   <Modal 
                                        centered
                                        withCloseButton={false}    
                                        opened={openedSyndicModal} 
                                        onClose={closeSyndicModal}
                                        size="auto">
                                            <Group noWrap mt="md" className=" txtCenter mrgT5 txt15">
                                                Valider la création du nouveau compte Syndic
                                            </Group>
                                            {error && <p className='txt13 rT'>Erreur : {error}</p>}
                                            <Group mt="xl" className="txtCenter horizontal spaceArd mrgT20 w80">
                                                <Button variant="outline" color="dark" onClick={handlecloseSyndicModal}>
                                                    Annuler
                                                </Button>
                                                <Button variant="filled" color="dark" onClick={formSyndic.onSubmit(handleSyndicFormSubmit)}  className=' medium'>
                                                    Valider
                                                </Button>
                                        </Group>       
                                    </Modal> 
                                :   ""
                            }  
                    </form>
                                        
                    <div className="mrgB30"></div>
                    {openConfirmationModal  
                            ?   <Modal 
                                    centered
                                    size="auto"
                                    
                                    opened={openedConfirmationModal}
                                    onClose={closeConfirmationModal}
                                    withCloseButton={false}>
                                    <p className=" txt15 txtCenter noMrgTB">
                                        Utilisateur enregistré avec succès
                                    </p>
                                </Modal> 
                            :   ""
                    }
                </div>
            </>
        )}
        </>
    );
};


export default AddCustomer;